/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Tour_Home_TitleInputs */

const en_wc_tour_home_title = /** @type {(inputs: Wc_Tour_Home_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Home & live Styles`)
};

/**
* | output |
* | --- |
* | "Home & live Styles" |
*
* @param {Wc_Tour_Home_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_tour_home_title = /** @type {((inputs?: Wc_Tour_Home_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Tour_Home_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_tour_home_title(inputs)
});
export { wc_tour_home_title as "wc.tour.home.title" }